<template>
  <el-button :file-key="fileKey" size="mini" type="primary" @click="downLoadFile">下载</el-button>
</template>

<script>
  const ossUrl = ".oss-cn-shanghai.aliyuncs.com";
  export default {
    props: {
      fileKey: {
        type: String,
        default: "",
      },
    },

    methods: {
      downLoadFile() {
        if (this.fileKey) {
          if (this.fileKey.includes(ossUrl)) {
            window.open(this.fileKey);
            return;
          }
          this.$http.get("basic", `files/getDownloadUrl?key=${this.fileKey}`).then((res) => {
            if (res.success) {
              window.open(res.data);
            }
          });
        }
      },
    },
  };
</script>
